import React from 'react';
import TimelineItem from 'antd/lib/timeline/TimelineItem';
import { StatusV2 } from '../AircraftStatusV2';
import { Col, Row, Tooltip } from 'antd';
import { formatDisplayTime, formatDuration } from '../utils/timeUtils';
import { TrackPoint } from '../../../common/api/spidertracks-sdk/types/TrackData';
import { convertToMetres } from '../../Flying/Map/utils/helper';
import { UnitWrapper } from '../UnitWrapper';

const SHOW_AGL_THRESHOLD_METERS = 304.8; // 1000 feet

export interface ActivePointDetailLineItemProps {
  aircraftId: string;
  firstPoint: TrackPoint;
  latestPoint: TrackPoint;
  activeSOS: boolean;
  dateFormat: string;
  timeFormat: string;
  timezone: string;
}

function getAltitude(latestPoint: TrackPoint): { value: number; type: 'AMSL' | 'AGL' } {
  if (latestPoint.altitudeAgl === undefined) {
    return {
      value: Math.round(latestPoint.altitude),
      type: 'AMSL'
    };
  }
  const altitudeAglMeters = convertToMetres(latestPoint.altitudeAgl, latestPoint?.altitudeUnit)[0];
  if (altitudeAglMeters < SHOW_AGL_THRESHOLD_METERS) {
    return {
      value: Math.round(latestPoint.altitudeAgl),
      type: 'AGL'
    };
  } else {
    return {
      value: Math.round(latestPoint.altitude),
      type: 'AMSL'
    };
  }
}
export const ActivePointDetailLineItem: React.FC<ActivePointDetailLineItemProps> = ({
  aircraftId,
  firstPoint,
  latestPoint,
  activeSOS,
  dateFormat,
  timeFormat,
  timezone
}) => {
  const dateTimeFormat = `${dateFormat} ${timeFormat}`;
  const spiderTime = formatDuration(firstPoint.timestamp, latestPoint.timestamp);
  const spiderTimeDuration = spiderTime.split(' ')[0];
  const spiderTimeUnit = spiderTime.split(' ')[1];

  return (
    <TimelineItem dot={<StatusV2 aircraftId={aircraftId} />}>
      <Row style={{ marginLeft: '5px' }}>
        <Col span={4} style={{ textAlign: 'left' }}>
          <span>
            <b>{formatDisplayTime(latestPoint.timestamp, timezone, dateTimeFormat, 'HH:mm')}</b>
          </span>
        </Col>
        <Col span={8} style={{ textAlign: 'end' }}>
          <span>
            <b>{getAltitude(latestPoint).value} </b>
            <UnitWrapper
              unit={`${latestPoint.altitudeUnit}`}
              type={getAltitude(latestPoint).type}
              activeSOS={activeSOS}
            />
          </span>
        </Col>
        <Col span={6} style={{ textAlign: 'end' }}>
          <span>
            <b>{Math.round(latestPoint.speed)} </b>
            <UnitWrapper unit={latestPoint.speedUnit} activeSOS={activeSOS} type={undefined} />
          </span>
        </Col>
        <Col style={{ textAlign: 'end' }}>
          <Tooltip title="Spider Time" placement="right">
            <span>
              <b>{spiderTimeDuration} </b>
              <UnitWrapper
                unit={spiderTimeUnit}
                type={undefined}
                activeSOS={activeSOS}
              ></UnitWrapper>
            </span>
          </Tooltip>
        </Col>
      </Row>
    </TimelineItem>
  );
};
